import request from '../../../../util/request';
import Cookies from 'js-cookie';
export function uploadImgRequest(file, fileName, callback) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName);
    return request(
        '/upload',
        {
            method: 'POST',
            body: formData,
        },
        callback
    );
}

export function createBotRequest(
    space_id,
    name,
    description,
    icon_file_id,
    prompt,
    prologue,
    suggested_questions,
    callback
) {
    return request(
        '/cBot',
        {
            method: 'POST',
            body: {
                space_id,
                name,
                description,
                icon_file_id,
                prompt,
                prologue,
                suggested_questions,
            },
        },
        callback
    );
}

export function getBotRequest(bot_id, callback) {
    return request(
        '/getBot',
        {
            method: 'POST',
            body: {
                bot_id,
            },
        },
        callback
    );
}

//获取知识库列表
export function getKcsList(data, callback) {
    return request(
        '/zhishiku/getDatasets',
        {
            method: 'POST',
            body: data,
        },
        callback
    );
}
//创建知识库
export function createKcs(data, callback) {
    return request(
        '/zhishiku/createDatasets',
        {
            method: 'POST',
            body: data,
        },
        callback
    );
}
//更新智能体的知识库
export function updateBotKnowledgeRequest(data, callback) {
  return request(
    '/uBot',
    {
      method: 'POST',
      body: Object.assign({},data,{"userToken":Cookies.get("userToken")}),
    },
    callback
  );
}

